import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import TabBar from "rc-tabs/lib/TabBar";
import { Link } from "react-router-dom";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import "./styles/HistorialSalidas.css";
import {
    ESTADOS_PALETIZACION,
    ESTADOS_PRODUCCION,
} from "../../../../../../../utility/constants";

class HistorialSalidas extends Component {
    render() {
        const { user } = this.props;

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Salidas"
                    noBorder
                >
                    <Listado storageKey="prod_bod_salidas_state" />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(HistorialSalidas);
